<template>
<!--  <v-card height="385">-->
    <v-footer
            color="#282828"
            absolute
            :padless="true"
    >
        <v-container>
            <v-row>
                <v-col xs="6" sm="4" md="2">
                    <v-list
                            flat
                            style="background-color: transparent;"
                            dark
                            dense
                    >
                        <v-list-item @click="navigate('sign-up')">
                          Our story
                        </v-list-item>
                        <v-list-item @click="navigate('organisations')">
                          Organisations
                        </v-list-item>
                        <v-list-item @click="navigate('products')">
                            Members shop
                        </v-list-item>
                        <v-list-item @click="navigate('activate')">
                          Activate tags
                        </v-list-item>
                        <v-list-item @click="navigate('environment')">
                          Our environment
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col xs="6" sm="4" md="2">
                    <v-list
                            flat
                            style="background-color: transparent;"
                            dark
                            dense
                    >
                        <v-list-item @click="navigate('sign-up')">
                          Create account
                        </v-list-item>
                        <v-list-item @click="helpDialog = true">
                          Contact us
                        </v-list-item>
                        <v-list-item @click="navigate('cookies')">
                            {{ $t('menu.Cookie declaration') }}
                        </v-list-item>
                        <v-list-item @click="navigate('privacy-policy')">
                            {{ $t('menu.Privacy policy') }}
                        </v-list-item>
                        <v-list-item @click="navigate('terms-and-conditions')">
                          {{ $t('menu.Terms and conditions') }}
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col xs="12" sm="4" md="2" offset-md="6" class="d-flex justify-end">
                    <v-btn
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.facebook.com/FindMyKit"
                        target="_blank"
                    >
                      <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <v-btn
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.instagram.com/findmykitofficial"
                        target="_blank"
                    >
                      <v-icon>mdi-instagram</v-icon>
                    </v-btn>
                    <v-btn
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.linkedin.com/company/findmykit-com"
                        target="_blank"
                    >
                      <v-icon>mdi-linkedin</v-icon>
                    </v-btn>

                    <v-btn
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.youtube.com/channel/UCjNqynJSSu8vD5BjPPWy-HA"
                        target="_blank"
                    >
                      <v-icon>mdi-youtube</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
          <v-row>
            <v-col>
              <div class="copyright text-center">
                <span class="white--text">&copy; {{ brandName }} Ltd {{ new Date().getFullYear() }}</span>
              </div>
            </v-col>
          </v-row>

        </v-container>

      <v-dialog max-width="600" v-model="helpDialog" rounded>
        <v-card>
          <v-card-title class="text-h5">
            Need a hand? We’ve got you covered!
          </v-card-title>

          <v-card-text>
            <p>To find answers to frequently asked questions in our searchable Help Centre, to request assistance from <strong><i>Kit</i></strong> our virtual assistant, or to request support from a member of our team, please use our support widget located at the bottom right of this page.</p>
          </v-card-text>

          <v-card-actions class="pb-6">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                rounded
                @click="openChatWidget"
            >
              okay, I got that
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-footer>
<!--  </v-card>-->
</template>

<script>

    import {mapState} from "vuex";

    let findmyweather = require('@/assets/findmyweatherlogowhite.png')
    let icoLogo = require('@/assets/icologonobackgroundwhite.png')

    export default {
        name: "Footer",
        data () {
            return {
                findmyweather: findmyweather,
                icoLogo: icoLogo,
                helpDialog: false,
            }
        },
        methods: {
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
            openChatWidget() {
              this.helpDialog = false
              if (window.fcWidget.isOpen() !== true) {
                window.fcWidget.open();
              }
            },
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName,
          }),
          playLink() {
            if (this.brand === 'neotag') {
              return 'https://play.google.com/store/apps/details?id=neotagApp.expo'
            }
            else {
              return 'https://play.google.com/store/apps/details?id=findmykitScanningApp.expo'
            }
          },
          iosLink() {
            if (this.brand === 'neotag') {
              return 'https://apps.apple.com/gb/app/id1662911631'
            }
            else {
              return 'https://apps.apple.com/gb/app/id1527760767'
            }
          }
        }
    }
</script>

<style scoped>
    footer {
      padding: 20px 0;
      border-radius: 0 !important;
    }
    footer a {
      color: white;
    }
    .social:hover {
        text-decoration: none;
    }
</style>
